import React, { useContext } from 'react';
import AppContext from './AppContext';

const getPokemonFrontSpriteUrl = (clickedSpeciesId: string) => `https://raw.githubusercontent.com/nationalpokedex/phms/main/sprites/${clickedSpeciesId}.png`;

function PokedexSprite() {
  const { dex, clickedSpeciesId } = useContext(AppContext);
  if (clickedSpeciesId == null) {
    return (
      <div>
        No data.
      </div>
    );
  }
  const pokemon = dex[clickedSpeciesId];
  return (
    <img
      width="108"
      height="108"
      alt={pokemon.name}
      src={getPokemonFrontSpriteUrl(clickedSpeciesId)}
    />
  );
}

export default PokedexSprite;
